import { Theme } from "../../../components/constants";

export default {
    container: {
        width: "70%",
        margin: "auto"
    },
    cardHeading: {
        color: Theme.PRIMARY,
    },
    titleText: {
        lineHeight: "normal",
    },
    subtitleText: {
        lineHeight: "normal",
        marginBottom: "0px"
    },
    offerCardText: {
        borderRadius: "4px",
        backgroundColor: "#E5EEFA",
        flexDirection: "row",
        columnGap: "20px",
        padding: "10px",
        alignItems: "center"
    },
    waitListFormContainer: {
        padding: "10px 0px"
    },
    fs15: {
        fontSize: "15px"
    }

}